import { Component, DestroyRef, OnInit } from '@angular/core';
import { NotificationService } from '@markant-platform/notifications/data-access';
import { skip } from 'rxjs';
import { CMSLanguageService } from '@markant-platform/shared/data-access';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'markant-platform-notification-banner',
  templateUrl: './notification-banner.component.html',
  styleUrls: ['./notification-banner.component.scss'],
})
export class NotificationBannerComponent implements OnInit {
  messages: string[] = [];

  constructor(
    private readonly notificationService: NotificationService,
    private readonly cmsLanguageService: CMSLanguageService,
    private readonly destroyRef: DestroyRef
  ) {}

  ngOnInit(): void {
    this.cmsLanguageService.activeCMSLanguage$.pipe(skip(1), takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.loadData();
    });
    this.loadData();
  }

  loadData(): void {
    this.notificationService
      .getActiveBannerNotifications()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(notifications => {
        // the notification with the oldest startDate will be the first displayed
        this.messages = notifications.map(({ message: { content } }) => content);
      });
  }
}
